import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import type * as fhirTypes from "fhir/r4";

export interface CareTeamResponse {
  careteam: fhirTypes.CareTeam;
}

export const useCareTeam = (patientId: string) => {
  return useApi<CareTeamResponse>({
    queryOptions: {
      enabled: true,
      queryFn: async () => {
        const response = await axiosInstance.get<CareTeamResponse>(
          "/clinic/careteam/",
          {
            params: {
              patientId,
            },
          },
        );

        return response.data;
      },
      queryKey: QueryKeys.Patient.Chat.CareTeam.DEFAULT(patientId),
    },
  });
};
